import { ICON_PATHS } from './icons';

/**
 * Один раз инжектит скрытый SVG-спрайт с symbol#i-<name> в <body>.
 * Иконки рендерятся через <svg class="ic"><use href="#i-name"/></svg> (Icon.vue).
 * Offline-safe: пути зашиты в бандл, без сетевых запросов (§6.7 брифа — без эмодзи).
 */
export function injectIconSprite(): void {
  if (document.getElementById('lucide-sprite')) return;
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns, 'svg');
  svg.id = 'lucide-sprite';
  svg.setAttribute('aria-hidden', 'true');
  svg.style.position = 'absolute';
  svg.style.width = '0';
  svg.style.height = '0';
  svg.style.overflow = 'hidden';
  let html = '';
  for (const [name, path] of Object.entries(ICON_PATHS)) {
    html += `<symbol id="i-${name}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round">${path}</symbol>`;
  }
  svg.innerHTML = html;
  document.body.insertBefore(svg, document.body.firstChild);
}
